import AutomatedForm from "./components/AutomatedForm";
import OneTimeForm from "./components/OneTimeForm";

export enum EDistributionTabs {
  Automated = 0,
  OneTime,
}

export const emailDistributionTabData = [
  {
    index: EDistributionTabs.Automated,
    label: "automated",
    children: <AutomatedForm />,
  },
  {
    index: EDistributionTabs.OneTime,
    label: "one_time",
    children: <OneTimeForm />,
  },
];
